var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyTulu2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2066",
    transform: "translate(710 1079)",
    style: {
      fill: "#fff"
    },
    d: "M0 0h75v75H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Smart maintenance system",
    transform: "translate(-710 -1079)",
    style: {
      clipPath: "url(#a)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 737"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 733"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4232",
    d: "M737.748 1148.665a.864.864 0 0 1-.863-.864v-20.043a.864.864 0 0 1 1.727 0v20.043a.864.864 0 0 1-.864.864z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 734"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4233",
    d: "M741.078 1153.664h-3.333a3.71 3.71 0 0 1-3.707-3.706v-42.324a13.4 13.4 0 0 1-1.124-24.007.864.864 0 0 1 1.283.755v9.243a2.08 2.08 0 0 0 2.078 2.078h6.273a2.079 2.079 0 0 0 2.077-2.078v-9.243a.864.864 0 0 1 1.283-.755 13.4 13.4 0 0 1-1.124 24.007v42.324a3.71 3.71 0 0 1-3.706 3.706zm-8.608-67.7a11.672 11.672 0 0 0 2.742 20.288.862.862 0 0 1 .553.8v42.9a1.983 1.983 0 0 0 1.98 1.98h3.333a1.982 1.982 0 0 0 1.979-1.98v-42.9a.862.862 0 0 1 .553-.8 11.672 11.672 0 0 0 2.742-20.288v7.663a3.808 3.808 0 0 1-3.8 3.8h-6.273a3.809 3.809 0 0 1-3.805-3.8z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 735"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4234",
    d: "M764.86 1129.444h-5.948a.748.748 0 0 1-.749-.748v-29.97a.995.995 0 0 1-.022-.058l-1.431-4.357a.742.742 0 0 1-.159-.5l.009-.092a.8.8 0 0 1 .015-.154l1.013-10.537a.748.748 0 0 1 .745-.676h7.1a.747.747 0 0 1 .745.676l1.007 10.462a.769.769 0 0 1 .027.29v.031a.751.751 0 0 1-.181.561l-1.409 4.293-.022.06v29.968a.748.748 0 0 1-.74.751zm-5.2-1.5h4.452v-29.508a.746.746 0 0 1 .179-.487l1.411-4.3-.944-9.8h-5.745l-.943 9.8 1.425 4.34a.7.7 0 0 1 .165.442z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 736"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4235",
    d: "M764.86 1152.994h-5.948a.863.863 0 0 1-.864-.863v-16.227c-3.767-2.02-3.767-2.679-3.767-3a.861.861 0 0 1 .077-.356l1.874-4.141a.862.862 0 0 1 .786-.507h9.735a.861.861 0 0 1 .786.507l1.874 4.141a.862.862 0 0 1 .078.356c0 .322 0 .978-3.768 3v16.227a.863.863 0 0 1-.863.863zm-5.085-1.726h4.226v-15.883a.862.862 0 0 1 .461-.764 36.05 36.05 0 0 0 3.14-1.9l-1.4-3.1h-8.622l-1.4 3.1c.738.534 2.465 1.546 3.139 1.9a.865.865 0 0 1 .463.765z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyTulu2);
export default __webpack_public_path__ + "static/media/myTulu2.53dc0b4e4988a6f5139e5e397a56689b.svg";
export { ForwardRef as ReactComponent };